// extracted by mini-css-extract-plugin
export default {"negative":"Balance_negative__JGK1K","positive":"Balance_positive__OK7Ux","background":"Balance_background__eEf0E"};